module.exports = __webpack_public_path__ + "img/20191006112255360截图20191006111150981.9404bca4.jpg";